<template>
  <div class="wrapper">
    <div class="container text-center">
      <div class="md-layout sectionTitles">
        <div
          class="
            md-layout-item md-size-66 md-xsmall-size-100
            ml-auto
            mr-auto
            text-center
          "
        >
          <h2 class="sectionTitle">Geossintéticos</h2>
          <div class="sectionSubTitle">produtos</div>
        </div>
        <div class="whatOfferInner" style="text-align: justify">
          <p class="classP">
            Os geossintéticos são produtos industrializados, onde pelo menos um
            de seus componentes é fabricado com polímeros sintéticos ou
            naturais, e que servem para solucionar problemas na área de
            geotecnia. Há anos esta tecnologia vem ganhando espaço no mercado,
            devido à capacidade de solucionar antigos problemas na engenharia e
            reduzindo os custos com materiais e mão de obra.
          </p>
          <p class="classP">
            Por sua versatilidade, os geossintéticos desempenham funções entre
            as quais se destacam separação, filtração, drenagem, reforço,
            contenção de fluidos/gases, e controle de processos erosivos.
            Dependendo do caso o produto pode apresentar mais de uma função.
          </p>
          <p class="classP">
            O desenvolvimento dessa tecnologia possibilita a simplificação de
            vários problemas nas obras de engenharia, tais como construções
            sobre solos frágeis, ganho de estabilidade em taludes com dimensão e
            inclinação menores, drenagem de vias e áreas especiais, mitigação da
            erosão do solo, entre outros.
          </p>
        </div>
      </div>
    </div>
    <div class="container text-center">
      <div class="md-layout sectionTitles">
        <div
          class="
            md-layout-item md-size-66 md-xsmall-size-100
            ml-auto
            mr-auto
            text-center
          "
        >
          <h2 class="sectionTitle">Nossos Serviços</h2>
          <div class="sectionSubTitle">o que oferecemos</div>
        </div>
        <nav-pills></nav-pills>
      </div>
    </div>
    <div
      class="section section-javascript sectionTitles"
      style="padding-top: 10px; padding-bottom: 0px"
    >
      <div
        class="
          md-layout-item md-size-66 md-xsmall-size-100
          ml-auto
          mr-auto
          text-center
        "
      >
        <h2 class="sectionTitle">Produtos Centergeo</h2>
        <div class="sectionSubTitle">para sua obra</div>
      </div>
      <div class="container">
        <carousel></carousel>
      </div>
    </div>
    <div
      class="container text-center"
      style="padding-top: 10px; padding-bottom: 0px"
    >
      <div class="md-layout sectionTitles">
        <div
          class="
            md-layout-item md-size-66 md-xsmall-size-100
            ml-auto
            mr-auto
            text-center
          "
        >
          <h2 class="sectionTitle">Solicite seu Orçamento</h2>
          <div class="sectionSubTitle">contate-nos</div>
        </div>
        <orcamento></orcamento>
      </div>
    </div>
  </div>
</template>

<script>
import NavPills from "../components/NavPillsSection";
import Carousel from "../components/CarouselSection";
import Orcamento from "../components/Orcamento";

export default {
  name: "index",
  bodyClass: "index-page",
  components: { NavPills, Carousel, Orcamento },
};
</script>